import { RecordlyVideoDemoPlayer } from '../demo/RecordlyVideoDemoPlayer';

export function InteractiveVideoDemoSection() {
  return (
    <section id="live-video-demo" className="py-20 sm:py-24 bg-white scroll-mt-24">
      <div className="max-w-[1380px] mx-auto px-5 sm:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="text-4xl sm:text-[48px] lg:text-[56px] font-normal tracking-[-0.03em] text-[#000000] leading-[1.12] mb-4">
            Inside the Rooflyzer workspace
          </h2>
          <p className="text-base sm:text-[18px] text-[#323338] leading-[1.55] font-normal">
            Walk through the live product across AI reception, measured 3D roof estimates, lead
            management, and invoicing.
          </p>
        </div>

        <RecordlyVideoDemoPlayer />
      </div>
    </section>
  );
}
